module.exports = __webpack_public_path__ + "static/media/Withum_Logo.83e09867.png";